import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import * as PartnerCaseService from "../../Services/PartnerCase/PartnerCaseService";
import { useEffect } from "react";
import { store } from "../../Store/store";
import {
  FileIcons,
  LoadingMessage,
  allowedTypes,
  API_DOMAIN,
  API_HEADER,
} from "../../Common/CommonVariables";
import { FaRegTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const RaiseComplaint = ({ showModal, setShowModal, vid }) => {

  const [complaintTypeShow, setComplaintTypeShow] = useState(false);
  const [caseCreationModalShow, setCaseCreationModalShow] = useState(false);
  const [selectedComplaintType, setSelectedComplaintType] = useState(null);
  const [selectedComplaintTypeID, setSelectedComplaintTypeID] = useState(null);
  const [CaseRecordTypeDetialList, setCaseRecordTypeDetialList] = useState([]);
  const [activeTab, setActiveTab] = useState("caseInfo");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [UploadedFileAttachmentList, setUploadedFileAttachmentList] = useState(
    []
  );
  const [filteredPartnerComplaintList, setFilteredPartnerComplaintList] =
    useState([]);
  const [dateRangeOption, setDateRangeOption] = useState("Today");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [SearchLoading, setSearchLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  //case description dd hooks
  const [caseCategoryList, setCaseCategoryList] = useState([]);
  const [srTypeList, setSrTypeList] = useState([]);
  const [srSubTypeList, setSrSubTypeList] = useState([]);

  //VID dd hooks
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const debounceRef = useRef(null);

  const fileInputRef = useRef(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    register: registerEditCase,
    formState: { errors: errorEditCase },
  } = useForm({
    defaultValues: {
      level: undefined,
    },
  });

  const level = watch("level");

  const partnerInfo = store.getState();

  const navigate = useNavigate()

  //   useEffect(() => {
  //     if (dateRangeOption !== "Custom") {
  //       fetchPartnerComplaints();
  //     }
  //   }, [dateRangeOption]);

  useEffect(() => {
    if (showModal) {
      getAllCaseRecordTypeList();
      reset();
    }
  }, [showModal]);

  const handleComplaintTypeClose = () => {
    setSelectedComplaintType("");
    setSelectedComplaintTypeID("");
    setComplaintTypeShow(false);
    setShowModal(false); 
  };

  const handleProceed = () => {
    if (!selectedComplaintType) {
      toast.error("Please select a complaint type.");
      return;
    }
    setComplaintTypeShow(false);
    setCaseCreationModalShow(true);
  };

  useEffect(() => {
      fetchPartner_CaseCategoryList();
    }, [])
  
    const fetchPartner_CaseCategoryList = () => {
      PartnerCaseService.GetPartner_CaseCategoryList()
        .then(({ data }) => {
          if (data.IsSuccess) {
            setCaseCategoryList(data.Data);
          } else {
            setCaseCategoryList([]);
          }
        })
        .catch(() => toast.error("Something went wrong."))
        .finally(() => { });
    }

  const handleCaseCategoryDD_Change = (event) => {
    const selectedOption = event.target.selectedOptions[0];
    const raisedId = selectedOption
      ? selectedOption.getAttribute("data-casecategoryid")
      : null;
    if (raisedId) {
      fetchPartner_SR_TypeList_ByCategoryId(raisedId);
    }
  };

  const handleSR_TypeDD_Change = (event) => {
    //debugger;
    const selectedOption = event.target.selectedOptions[0];
    const raisedId = selectedOption
      ? selectedOption.getAttribute("data-srtypeid")
      : null;
    if (raisedId) {
      fetchPartner_SR_SubTypeList_ByCategoryId(raisedId);
    }
  };

  const fetchPartner_SR_SubTypeList_ByCategoryId = (srId) => {
    PartnerCaseService.GetPartner_SR_SubTypeList_ByCategoryId(srId)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setSrSubTypeList(data.Data);
        } else {
          setSrSubTypeList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => {});
  };

  const fetchPartner_SR_TypeList_ByCategoryId = (categoryId) => {
    PartnerCaseService.GetPartner_SR_TypeList_ByCategoryId(categoryId)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setSrTypeList(data.Data);
        } else {
          setSrTypeList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => {});
  };

  const getAllCaseRecordTypeList = () => {
    setSelectedComplaintType(null);
    PartnerCaseService.GetCaseRecordTypeList()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setCaseRecordTypeDetialList(data.Data);
          setComplaintTypeShow(true);
        } else {
          setCaseRecordTypeDetialList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const handlePrevious = () => {
    if (activeTab === "case_description") {
      setActiveTab("caseInfo");
    } else if (activeTab === "upload_attachment") {
      setActiveTab("case_description");
    } else {
      setComplaintTypeShow(true);
      setCaseCreationModalShow(false);
    }
  };

  const handleModalClose = () => {
    reset();
    setCaseCreationModalShow(false);
    setActiveTab("caseInfo");
    setSelectedFiles([]);
    setShowModal(false); 
  };

  if (!showModal) {
    return null;
  }

  const handleSelect = (val) => {
    setInputValue(val.MHL_ExternalVID__c);
    setValue("Customer_VID", val.MHL_ExternalVID__c);
    setShowDropdown(false);
  };

  const handleFileChange = (event) => {
    const maxFiles = 5;
    const file = event.target.files;
    const maxFileSize = 5 * 1024 * 1024; // 5MB

    if (!file || file.length === 0) {
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      return;
    }

    if (file) {
      if (!allowedTypes.includes(file[0].type) || file[0].size > maxFileSize) {
        toast.error("File is either unsupported or exceeds the 5MB limit.");
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        return;
      }

      if (selectedFiles.length >= maxFiles) {
        toast.error(`You can only upload up to ${maxFiles} files.`);
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        return;
      }

      const alreadyExists = selectedFiles.some(
        (f) => f.name === file[0].name && f.size === file[0].size
      );
      if (alreadyExists) {
        toast.error("This file is already selected.");
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        return;
      }
      const filesArray = Array.from(event.target.files);

      // You can add logic here to determine which section/document to update
      setSelectedFiles((prevFiles) => [...prevFiles, ...filesArray]);
    }
  };

  const handleFileUpload = () => {
    setLoading(true);
    const formData = new FormData();

    const uploadedTitles = UploadedFileAttachmentList.map((file) => file.Title);
    const newFilesToPush = selectedFiles.filter(
      (file) => !uploadedTitles.includes(file.name)
    );

    newFilesToPush.forEach((file) => {
      formData.append("Myfile", file);
    });

    if (newFilesToPush.length <= 0) {
      toast.error("Please select file first!");
      setLoading(false);
      return;
    }
    PartnerCaseService.UploadMultiplePartner_SalesForce_Document(formData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
          setUploadedFileAttachmentList((prevList) => [
            ...prevList,
            ...data.Data,
          ]);
          toast.success(data.Data.length + " files uploaded successfully.");
        } else {
          // setUploadedFileAttachmentList([])
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  const handleRemoveIndividualFile = (fileToRemove) => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter(
        (file) =>
          !(file.name === fileToRemove.name && file.size === fileToRemove.size)
      )
    );

    // Also remove from uploaded attachment list if it exists there
    setUploadedFileAttachmentList((prevList) =>
      prevList.filter(
        (file) =>
          !(file.name === fileToRemove.name && file.size === fileToRemove.size)
      )
    );

    // Clear the file input to reset it
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setValue("Customer_VID", value); // update react-hook-form state

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      if (value.length >= 3) {
        // PartnerCaseService.GetCasePatientDetails(value, partnerInfo.userData.Partner_Code)
        PartnerCaseService.GetCasePatientDetails(
          value,
          partnerInfo?.Partner_Account_Details?.MHL_Client_Code__c
        )
          .then(({ data }) => {
            if (data.IsSuccess) {
              setOptions(data.Data);
              setShowDropdown(true);
            } else {
              setOptions([]);
              setShowDropdown(false);
            }
          })
          .catch(() => toast.error("Something went wrong."))
          .finally(() => {});
      } else {
        setOptions([]);
        setShowDropdown(false);
      }
    }, 300); // 300ms debounce
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "caseInfo":
        return (
          <div className="container">
            <div className="row g-3">
              {/* First Row */}
              <div className="col-md-6">
                <div className="col-md-12">
                  <div className="mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: "80px" }}>
                        <strong style={{ width: "120px" }}>Name</strong>
                      </div>
                      <div>
                        <span className="case-infodata">
                          : {partnerInfo?.Partner_Account_Details?.Name}
                        </span>
                      </div>
                    </div>
                    <input
                      type="hidden"
                      {...register("Customer_Name")}
                      value={partnerInfo?.Partner_Account_Details?.Name}
                    />
                    <input
                      type="hidden"
                      {...register("AD_ID__c")}
                      value={partnerInfo?.Partner_Account_Details?.AD_ID__c}
                    />
                    <input
                      type="hidden"
                      {...register("Id")}
                      value={partnerInfo?.Partner_Account_Details?.Id}
                    />
                    <input
                      type="hidden"
                      {...register("RecordTypeId")}
                      value={selectedComplaintTypeID}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: "80px" }}>
                        <strong>Client Code</strong>
                      </div>
                      <div>
                        <span>
                          :{" "}
                          {
                            partnerInfo?.Partner_Account_Details
                              ?.MHL_Client_Code__c
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <input
                    type="hidden"
                    {...register("Client_Code")}
                    value={
                      partnerInfo?.Partner_Account_Details?.MHL_Client_Code__c
                    }
                  />
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: "80px" }}>
                        <strong>Mobile</strong>
                      </div>
                      <div>
                        <span>
                          :{" "}
                          {
                            partnerInfo?.Partner_Account_Details
                              ?.MHL_Mobile_Number__c
                          }
                        </span>
                      </div>
                    </div>
                    <input
                      type="hidden"
                      {...register("Customer_Mobile")}
                      value={
                        partnerInfo?.Partner_Account_Details
                          ?.MHL_Mobile_Number__c
                      }
                    />
                  </div>
                </div>

                {/* Second Row */}

                <div className="col-md-12">
                  <div className="mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: "80px" }}>
                        <strong>Email</strong>
                      </div>
                      <div>
                        <span>
                          : {partnerInfo?.Partner_Account_Details?.MHL_Email__c}
                        </span>
                      </div>
                    </div>
                    <input
                      type="hidden"
                      {...register("Customer_Email")}
                      value={partnerInfo?.Partner_Account_Details?.MHL_Email__c}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: "80px" }}>
                        <strong>Location</strong>
                      </div>
                      <div>
                        <span>
                          : {partnerInfo?.Partner_Account_Details?.BillingCity}
                        </span>
                      </div>
                    </div>
                    <input
                      type="hidden"
                      {...register("Locations")}
                      value={partnerInfo?.Partner_Account_Details?.BillingCity}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="col-md-12">
                  <div className="mb-3">
                    <div style={{ fontSize: "14px" }}>
                      <strong>Select an Option: </strong>
                    </div>
                    <div className="mt-1 d-flex flex-column">
                      <div className="d-flex align-items-start flex-column">
                        <div className="form-check form-check-inline d-flex align-items-center">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="patientLevel"
                            value="patient"
                            {...register("level", {
                              required: "Level is required",
                            })}
                            style={{ border: "1px solid" }}
                          />
                          <label
                            className="form-check-label ms-1"
                            htmlFor="patientLevel"
                          >
                            Patient Level
                          </label>
                        </div>

                        <div className="form-check form-check-inline d-flex align-items-center">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="clientLevel"
                            value="client"
                            {...register("level")}
                            style={{ border: "1px solid" }}
                          />
                          <label
                            className="form-check-label ms-1"
                            htmlFor="clientLevel"
                          >
                            Client Level
                          </label>
                        </div>
                      </div>

                      {errors.level && (
                        <div className="text-danger ms-1">
                          {errors.level.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Third Row - VID field spans full width or partial width */}
                {level === "patient" && (
                  <div className="col-md-12 custom-vid-field">
                    <div className="mb-3" style={{ position: "relative" }}>
                      <div style={{ fontSize: "14px" }}>
                        <span className="text-danger">*</span> <b> VID</b>
                      </div>
                      <input
                        type="text"
                        className="form-control mt-1"
                        defaultValue={vid}
                        placeholder="Enter VID"
                        {...register("Customer_VID", {
                          // required: "Customer VID is required",
                          required:
                            level === "patient"
                              ? "Customer VID is required"
                              : false,
                          maxLength: {
                            value: 18,
                            message: "Maximum 18 characters allowed",
                          },
                          minLength: {
                            value: 15,
                            message: "Minimum 15 characters allowed",
                          },
                        })}
                        onChange={handleInputChange}
                      />
                      {showDropdown && options.length > 0 && (
                        <ul
                          className="list-group position-absolute w-100"
                          style={{
                            zIndex: 1000,
                            maxHeight: "200px",
                            overflowY: "auto",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          }}
                        >
                          {options.map((opt, index) => (
                            <li
                              key={index}
                              className="list-group-item list-group-item-action"
                              onClick={() => handleSelect(opt)}
                              style={{ cursor: "pointer" }}
                            >
                              {opt.MHL_ExternalVID__c}
                            </li>
                          ))}
                        </ul>
                      )}
                      {errors.Customer_VID && (
                        <span className="text-danger">
                          {errors.Customer_VID.message}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      case "case_description":
        return (
          <div className="container pl-2">
            {/* Row 1 */}
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label fw-bold required">
                  Case Raised For
                </label>
                <div className="case-select-wrapper">
                  <select
                    className="form-select case-dropdown"
                    defaultValue={""}
                    {...register("Case_Raised_Against", {
                      required: "Case Raised For is required",
                    })}
                    onChange={handleCaseCategoryDD_Change}
                  >
                    <option value="">Select Case Raised for</option>
                    {caseCategoryList.map((item) => (
                      <option
                        key={item.Id}
                        value={item.CaseCategory}
                        data-casecategoryid={item.Id}
                      >
                        {item.CaseCategory}
                      </option>
                    ))}
                  </select>
                  {errors.Case_Raised_Against && (
                    <p className="text-danger required_error">
                      {" "}
                      {errors.Case_Raised_Against.message}{" "}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold required">SR Type</label>
                <div className="case-select-wrapper">
                  <select
                    className="form-select case-dropdown"
                    defaultValue={""}
                    {...register("SR_Type", {
                      required: "SR Type is required",
                    })}
                    onChange={handleSR_TypeDD_Change}
                  >
                    <option value="">Select SR Type</option>
                    {srTypeList.map((item) => (
                      <option
                        key={item.SrId}
                        value={item.TypeName}
                        data-srtypeid={item.SrId}
                      >
                        {item.TypeName}
                      </option>
                    ))}
                  </select>
                  {errors.SR_Type && (
                    <p className="text-danger required_error">
                      {errors.SR_Type.message}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label fw-bold required">
                  SR Sub Type
                </label>
                <div className="case-select-wrapper">
                  <select
                    className="form-select case-dropdown"
                    {...register("SR_SubType", {
                      required: "SR Type is required",
                    })}
                  >
                    <option value="">Select SR Sub Type</option>
                    {srSubTypeList.map((item) => (
                      <option
                        key={item.SrSubTypeId}
                        value={item.SubTypeName}
                        data-edit-srtypeid={item.SrSubTypeId}
                      >
                        {item.SubTypeName}
                      </option>
                    ))}
                  </select>
                  {errors.SR_SubType && (
                    <p className="text-danger required_error">
                      {errors.SR_SubType.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold required">
                  Description
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter a description for the case"
                  {...register("Description", {
                    required: "Description is required",
                  })}
                ></textarea>
                {errors.Description && (
                  <p className="text-danger required_error">
                    {errors.Description.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        );
      case "upload_attachment":
        return (
          <div className="container" style={{ fontSize: "13px" }}>
            <div
              className="d-flex align-items-center gap-2 mb-2 pl-3"
              style={{ fontSize: "13px" }}
            >
              <label className="fw-bold mb-0-5">Upload Attachments</label>
              <input
                className="form-control"
                style={{ width: "250px" }}
                type="file"
                ref={fileInputRef}
                accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.webp,.bmp,.svg,.eml"
                onChange={handleFileChange}
              />
              <button
                className="btn custom-sumbitbtn"
                disabled={loading}
                type="button"
                onClick={handleFileUpload}
              >
                {" "}
                Upload{" "}
              </button>
              <div
                className="alert alert-info p-2 mt-1 pt-2"
                style={{
                  fontSize: "9px",
                  maxWidth: "350px",
                  marginBottom: "4px",
                  marginRight: "15px",
                }}
              >
                <strong>Note:</strong> You can upload a maximum of 5 files(less
                than 5MB).
                <br />
                Accepted files: <code>.pdf</code>, <code>.doc</code>,{" "}
                <code>.docx</code>, <code>.jpeg</code>, <code>.jpg</code>,{" "}
                <code>.png</code>, <code>.gif</code>, <code>.webp</code>,{" "}
                <code>.bmp</code>, <code>.svg</code>, <code>.eml</code>
              </div>
            </div>

            <ul className="list-group pl-3 pb-2 pt-1 col-md-6">
              {selectedFiles && selectedFiles.length > 0
                ? selectedFiles.map((file) => (
                    <li
                      key={file.ContentDocumentId}
                      className="list-group-item d-flex align-items-center justify-content-between"
                    >
                      <div>
                        {FileIcons[file.name.split(".").pop()] ||
                          FileIcons.other}
                        &nbsp;<span>{file.name}</span>
                      </div>
                      {/* <button type="button" disabled={loading} className="btn-close" onClick={() => handleRemoveIndividualFile(file)}></button> */}
                      <FaRegTrashAlt
                        disabled={loading}
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() => handleRemoveIndividualFile(file)}
                      />
                    </li>
                  ))
                : null}
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  //   const fetchPartnerComplaints = () => {
  //     //debugger;
  //     setFilteredPartnerComplaintList([]);
  //     if (!validateDateRange(startDate, endDate)) return;

  //     const requestData = buildRequestData(startDate, endDate);
  //     requestData.Client_Code =
  //       partnerInfo?.Partner_Account_Details?.MHL_Client_Code__c;

  //     setSearchLoading(true);
  //     setLoading(true);

  //     PartnerCaseService.PartnerCaseList_Filter(requestData)
  //       .then(({ data }) => {
  //         if (data.IsSuccess) {
  //           setFilteredPartnerComplaintList(data.Data);
  //         } else {
  //           setFilteredPartnerComplaintList([]);
  //         }
  //       })
  //       .catch(() => toast.error("Something went wrong."))
  //       .finally(() => {
  //         setLoading(false);
  //         setSearchLoading(false);
  //       });
  //   };

  //   const buildRequestData = (startDateValue, endDateValue) => ({
  //     StartDate: new Date(
  //       new Date(startDateValue).setHours(0, 0, 0, 0)
  //     ).toISOString(),
  //     EndDate: new Date(
  //       new Date(endDateValue).setHours(23, 59, 59, 999)
  //     ).toISOString(),
  //   });

  //   const validateDateRange = (startDateValue, endDateValue) => {
  //     if (!startDateValue || !endDateValue) {
  //       toast.error("Please select a date range");
  //       return false;
  //     }
  //     if (startDateValue > endDateValue) {
  //       toast.error("Start date cannot be after end date");
  //       return false;
  //     }
  //     if (endDateValue > new Date()) {
  //       toast.error("End date cannot be in the future");
  //       return false;
  //     }
  //     return true;
  //   };

  const onSubmit = (data) => {
    setLoading(true);
    if (activeTab === "caseInfo") {
      setActiveTab("case_description");
      setLoading(false);
    } else if (activeTab === "case_description") {
      setActiveTab("upload_attachment");
      setLoading(false);
    } else {
      if (selectedFiles.length !== UploadedFileAttachmentList.length) {
        alert("Please upload selected files first.");
        setLoading(false);
        return;
      }

      data.UploadedFileAttachmentList = UploadedFileAttachmentList;
      PartnerCaseService.CreatePartnerCase(data)
        .then(({ data }) => {
          if (data.IsSuccess) {
            setEndDate(new Date());
            setSelectedComplaintType("");
            setSelectedComplaintTypeID("");
            toast.success(data.Data + " - Complaint created successfully");
            handleModalClose();
            setActiveTab("caseInfo");
            navigate('/partnercase');
          } else {
            toast.error("Something went wrong.");
            setActiveTab("caseInfo");
          }
        })
        .catch(() => toast.error("Something went wrong."))
        .finally(() => setLoading(false));

    }
  };

  return (
    <>

      {complaintTypeShow && (
        <div className="modal-backdrop">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div
              className="modal-dialog modal-sm custom-modal-com"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">New Case</h5>
                  <button
                    type="button"
                    disabled={loading}
                    className="btn-close"
                    onClick={handleComplaintTypeClose}
                  ></button>
                </div>
                <div className="modal-body">
                  <div>
                    <label className="fw-bold required mb-0-5">
                      {" "}
                      Select a Record Type{" "}
                    </label>
                    {CaseRecordTypeDetialList.map((type) => (
                      <div key={type.RecordTypeId} className="form-check">
                        <input
                          type="radio"
                          id={type.RecordTypeId}
                          className="form-check-input form-check-newcase"
                          value={type.RecordTypeId}
                          checked={selectedComplaintType === type.RecordType}
                          onChange={() => {
                            setSelectedComplaintType(type.RecordType);
                            setSelectedComplaintTypeID(type.RecordTypeId);
                          }}
                        />
                        <label
                          htmlFor={type.RecordTypeId}
                          className="form-check-label"
                        >
                          {type.RecordType_Label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    disabled={loading}
                    className="btn btn-danger"
                    onClick={handleComplaintTypeClose}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    disabled={loading}
                    className="btn btn-primary"
                    onClick={handleProceed}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {caseCreationModalShow && (
        <div className="modal-backdrop">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div
              className="modal-dialog modal-lg custom-modal"
              style={{ maxWidth: "700px" }}
              role="document"
            >
              <div className="modal-content mb-0 p-0">
                <div className="modal-header p-2-5">
                  <h5 className="modal-title">
                    New Case: {selectedComplaintType}
                  </h5>
                  <button
                    type="button"
                    disabled={loading}
                    className="btn-close"
                    onClick={handleModalClose}
                  ></button>
                </div>
                <div className="modal-body p-0">
                  <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <ul className="nav nav-tabs mb-2">
                      <li className="nav-item">
                        <button
                          type="button"
                          className={`tab-button-header nav-link 
                              ${
                                activeTab === "caseInfo"
                                  ? "active highlighted-tab"
                                  : ""
                              } `}
                          onClick={() => setActiveTab("caseInfo")}
                          // style={{ cursor: "default" }}
                        >
                          Case Information
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          type="button"
                          className={`tab-button-header nav-link 
                              ${
                                activeTab === "case_description"
                                  ? "active highlighted-tab"
                                  : ""
                              }`}
                          onClick={() => setActiveTab("case_description")}
                          // style={{ cursor: "default" }}
                        >
                          Case Description
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          type="button"
                          className={`tab-button-header  nav-link 
                              ${
                                activeTab === "upload_attachment"
                                  ? "active highlighted-tab"
                                  : ""
                              }`}
                          onClick={() => setActiveTab("upload_attachment")}
                          // style={{ cursor: "default" }}
                        >
                          Upload Attachments
                        </button>
                      </li>
                    </ul>
                    {renderTabContent()}
                    <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                      <button
                        type="button"
                        disabled={loading}
                        className="btn btn-secondary"
                        onClick={handlePrevious}
                      >
                        {" "}
                        Previous{" "}
                      </button>
                      <button
                        type="submit"
                        disabled={loading}
                        className="btn custom-sumbitbtn"
                      >
                        {/* Old code */}
                        {/* {activeTab === "upload_attachment"
                          ? "Save"
                          : "Save & Next"} */}

                          {/* New Code with loader */}
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            </>
                          ) : activeTab === "upload_attachment" ? (
                            "Save"
                          ) : (
                            "Save & Next"
                          )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RaiseComplaint;
